import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { map , tap} from 'rxjs/operators';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EmployeeType } from '../entities/employeeType';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EmployeeTypeService extends BaseCrudService<EmployeeType> {

  public uri = '/api/employeeType/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployeeTypeService');
  }

  buildSentence(entity?: EmployeeType, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.name ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.acronym ? 'acronym'
          + QueryOperator.Contain + entity.acronym
          + QueryOperator.Split : QueryOperator.Empty
      );
      if (entity.laborLaw) {
        query = query.concat(
          entity.laborLaw.id ? 'laborLaw.id' + QueryOperator.Equal
            + entity.laborLaw.id + QueryOperator.Split : QueryOperator.Empty
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }


  /** 

  searchToReport(entity?: AbsenceLeave, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<AbsenceLeave>> {

    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<AbsenceLeave>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          } 
          this.spinnerService.hideAll();
          return response;
        })
      );
  }
*/
  searchFilters(entity?: EmployeeType, event?: LazyLoadEvent, extraQueryCondition?: Number[]): Observable<ResponsePageable<EmployeeType>> {

    const url = this.rutaServidor + this.uri;
    this.spinnerService.showAll();
    return this.httpClient.get<ResponsePageable<EmployeeType>>(url, { params: this.buildSentence(entity, event) })
        .pipe(
            tap(response => {
              let responseFilter : EmployeeType[]=[];
                if (response.numberOfElements > 0) {
                    response.content.forEach((value) => {
                        // debugger;
                        this.addLogicToSearch(value);
                        this.convertToDate(value);
                    })
                    for(var i=0; response.content.length>i;i++){
                      for(var j=0; extraQueryCondition.length>j;j++){
                        if(response.content[i].id==extraQueryCondition[j]){
                          responseFilter.push(response.content[i]);
                        } 
                      }
                    } 
                    response.content =responseFilter;
                    response.numberOfElements = responseFilter.length;
                }
               //console.log(response);
                this.spinnerService.hideAll();
                return response;
            })
        );
}

}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-type.service.ts